"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { useActiveProject } from "@/context/active-project";
import { useUserProfile } from "@/context/user-profile";

export function ProjectDisplaySettingsBridge() {
  const { data: session, status } = useSession();
  const { activeProjectId } = useActiveProject();
  const { syncForcedProjectDisplay } = useUserProfile();

  useEffect(() => {
    if (status === "unauthenticated") {
      syncForcedProjectDisplay({ force: false, slice: null });
      return;
    }
    if (status === "loading") return;
    if (!activeProjectId) {
      syncForcedProjectDisplay({ force: false, slice: null });
      return;
    }

    const project = session?.user?.projects?.find((p) => p.id === activeProjectId);
    const ds = project?.displaySettings;
    if (!ds) {
      syncForcedProjectDisplay({ force: false, slice: null });
      return;
    }
    if (ds.forceDisplayForAllUsers && ds.slice) {
      syncForcedProjectDisplay({ force: true, slice: ds.slice });
    } else {
      syncForcedProjectDisplay({ force: false, slice: null });
    }
  }, [status, activeProjectId, session?.user?.projects, syncForcedProjectDisplay]);

  return null;
}
